// @flow

import type { EasyCompPure, EasyCompMap, Visitor } from './type'

import * as React from 'react'
import { connect } from 'react-redux'
import qs from 'qs'
import EasyCompComponent from './Comps/EasyCompComponent'
import { getFixedHeight } from './redux/fixedHeight'
import { getCmsData } from './cmsUtil'
import { convertPureToMap } from './Comps/util'
import { setVisitor } from './redux/basic'
import fengPerf from 'feng-performance'
import { alertError } from 'frame/ui/popup'
import * as analysis from 'frame/core/analysis'

type HocProps = {
  visitor: Visitor,
  height: number,
  code?: ?string,
  rootEasyComp?: ?EasyCompMap,
  preview?: boolean,
  isAbroad?: boolean
};

type Props = HocProps & {
  fixedHeight: { top: number, bottom: number }
};

type State = {
  rootEasyComp?: ?EasyCompMap
};

function mapStateToProps (state) {
  return {
    fixedHeight: getFixedHeight()
  }
}

class CMS extends React.PureComponent<Props, State> {
  state = {};
  query: { [string]: string };

  constructor (props) {
    super(props)
    const search = window.location.search
    this.query = search ? qs.parse(search.substr(1)) : {}
    setVisitor(props.visitor)
  }

  initCmsDataByCode (code: string, props: Props): void {
    const { preview, isAbroad } = props
    getCmsData({ code, preview, isAbroad })
      .then(cmsData => {
        if (cmsData.marketplace === 'ydd') {
          document.title = '喜鹊快贷'
        } else {
          if(window.location.href.indexOf('fengfd.com')>-1){
            document.title="凤凰金信";
          }else{
          document.title = '凤凰金融'
          }
        }

        this.setState({ rootEasyComp: null }, () => {
          const rootPure: ?EasyCompPure = cmsData.components
          if (rootPure) {
            this.setState({
              rootEasyComp: convertPureToMap(rootPure)
            })
          }
        })
        fengPerf.Performance.reactLoadReady()
      })
      .catch(e => {
        if (e.code === 0) {
          alertError('网络异常')
        }
      })
  }

  componentWillMount () {
    if (this.props.code) {
      // 非管理平台
      this.initCmsDataByCode(this.props.code, this.props)
    }
  }

  componentWillUpdate (nextProps) {
    if (nextProps.code && this.props.code !== nextProps.code) {
      this.initCmsDataByCode(nextProps.code, nextProps)
    }
    if (this.props.visitor !== nextProps.visitor) {
      setVisitor(nextProps.visitor)
    }
  }

  componentDidUpdate (nextProps) {
    if (nextProps.code && this.props.code !== nextProps.code) {
      analysis.trackPageview()
    }
  }

  render () {
    const { height, fixedHeight } = this.props
    const rootEasyComp = this.props.rootEasyComp || this.state.rootEasyComp
    if (!rootEasyComp) {
      return null
    }
    return (
      <div
        style={{
          height,
          overflow: 'auto',
          position: 'relative',
          paddingTop: fixedHeight.top,
          paddingBottom: fixedHeight.bottom
        }}
      >
        <EasyCompComponent easyCompMap={rootEasyComp} />
      </div>
    )
  }
}

const HocCms: React.ComponentType<HocProps> = connect(mapStateToProps)(CMS)

export default HocCms



// WEBPACK FOOTER //
// ./src/projects/easy/public/index.js